module.exports = __webpack_public_path__ + "static/media/alarm-clock.fd0174c8.svg";